import { gql } from 'apollo-angular';

export class Queries {
  public static readonly GET_ORGANISATIONS = gql`
    query AllOrganisations($searchTerm: String!) {
      organisations(
        where: {
          or: [
            { name: { contains: $searchTerm } },
            { organisationRef: { contains: $searchTerm } }
          ]
        },
        order: {
          name: ASC
        }
      ) {
        id
        name
        organisationRef
        domains
        parentOrganisations {
          id
          name
        }
      }
    }
  `;

  public static readonly GET_ORGANISATION = gql`
    query Organisation($organisationRef: String!) {
      organisation(
        organisationRef: $organisationRef
      ) {
        organisationRef
        domains
        referenceId
        id
        name
        applications {
            id
            referenceId
            name
            identifier
            roles (where: { implicit: { neq: true } } ) {
              name
            }
        }
        entityType
        organisationType
      }
    }
  `

  public static readonly GET_USERS = gql`
    query OrganisationUsers(
      $organisations: [String!]!,
      $searchTerm: String!,
      $canImpersonate: Boolean = false,
      $activeStatusQuery: LaunchPadUserFilterInput!,
      $impersonationQuery: LaunchPadUserFilterInput!
      ) {
      organisationUsers(
        orgRefs: $organisations
        where: {
          or: [
            { name: { contains: $searchTerm } },
            { firstName: { contains: $searchTerm } },
            { surname: { contains: $searchTerm } },
            { emailAddress: { contains: $searchTerm } },
          ],
          and: [
            $activeStatusQuery,
            $impersonationQuery
          ]
        }
        order: {
          firstName: ASC,
          surname: ASC
        }
      ) {
        id
        type
        name
        firstName
        surname
        emailAddress
        isActive
        isExternal
        deactivationDate
        deletionRequestedAt
        impersonationExpiry @include(if: $canImpersonate)
        lastLogin
        isTeamMember
        disableTeamMemberRestriction
        organisations {
          id
          organisationRef
          name
          organisationType
          applications {
            id
            identifier
            name
            roles (where: { implicit: { neq: true } } ) {
              name
            }
          }
        }
      }
    }
  `

  // Takes the same filter and order as GET_USERS, so a filtered export matches the users table
  public static readonly GET_USERS_EXPORT = gql`
    query OrganisationUsersExport(
      $organisations: [String!]!,
      $searchTerm: String!,
      $activeStatusQuery: LaunchPadUserFilterInput!,
      $impersonationQuery: LaunchPadUserFilterInput!,
      $exportType: ExportFormat!,
      $language: String!,
      $timeZone: String
      ) {
      organisationUsersExport(
        orgRefs: $organisations
        exportType: $exportType
        language: $language
        timeZone: $timeZone
        where: {
          or: [
            { name: { contains: $searchTerm } },
            { firstName: { contains: $searchTerm } },
            { surname: { contains: $searchTerm } },
            { emailAddress: { contains: $searchTerm } },
          ],
          and: [
            $activeStatusQuery,
            $impersonationQuery
          ]
        }
        order: {
          firstName: ASC,
          surname: ASC
        }
      ) {
        base64EncodedContent
        contentType
        fileName
      }
    }
  `

  public static readonly GET_USER = gql`
    query User($userId: String!) {
      user(
        userId: $userId
        includeImplicitRole: false
      ) {
        id
        type
        name
        firstName
        surname
        emailAddress
        isActive
        isExternal
        deactivationDate
        deletionRequestedAt
        isTeamMember
        disableTeamMemberRestriction
        organisations {
          id
          organisationRef
          name
          organisationType
          applications {
            id
            identifier
            name
            roles {
              name
            }
          }
        }
      }
    }
  `

  public static readonly CREATE_USER = gql`
    mutation CreateUser($user: UserInput!) {
      createUser(
          user: $user
      ) {
          type
          firstName
          surname
          emailAddress
          referenceId
          entityType
          id
          name
          isActive
          isExternal
      }
  }
  `

  public static readonly UPDATE_USER = gql`
    mutation UpdateUser($user: UserInput!) {
      updateUser(
          user: $user
      ) {
          type
          firstName
          surname
          emailAddress
          referenceId
          entityType
          id
          name
          isActive
          isExternal
      }
  }
  `

  public static readonly ACTIVATE_USER = gql`
    mutation ActivateUser($userEmail: String!) {
      activateUser(
          userEmail: $userEmail
      ) {
          type
          firstName
          surname
          emailAddress
          referenceId
          entityType
          id
          name
          isActive
          isExternal
      }
  }
  `

  public static readonly DEACTIVATE_USER = gql`
    mutation DeactivateUser($userEmail: String!) {
      deactivateUser(
          userEmail: $userEmail
      ) {
          type
          firstName
          surname
          emailAddress
          referenceId
          entityType
          id
          name
          isActive
          isExternal
      }
  }
  `

  public static readonly DELETE_USER = gql`
    mutation DeleteUser($userEmail: String!) {
      deleteUser(
          userEmail: $userEmail
      )
  }
  `

  public static readonly RESEND_USER_INVITE = gql`
    mutation ResendUserInvite($userEmail: String!) {
      resendUserInvite(
          userEmail: $userEmail
      ) {
          type
          firstName
          surname
          emailAddress
          referenceId
          entityType
          id
          name
          isActive
          isExternal
      }
  }
  `
}
